const l = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill="currentColor" d="M13.833 4.267H7.576a.28.28 0 0 1-.249-.148l-.526-1.013a.84.84 0 0 0-.745-.44h-3.89c-.46 0-.833.359-.833.8v9.067c0 .442.373.8.834.8h11.666c.46 0 .834-.358.834-.8V5.067c0-.442-.373-.8-.834-.8"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>';
export {
  l as default
};
